import { render, staticRenderFns } from "./CCaseEn.vue?vue&type=template&id=befe7da6"
import script from "./CCaseEn.vue?vue&type=script&lang=js"
export * from "./CCaseEn.vue?vue&type=script&lang=js"
import style0 from "./CCaseEn.vue?vue&type=style&index=0&id=befe7da6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports